

























































// eslint-disable-next-line
import { Component, Prop, Vue } from "vue-property-decorator";

interface User {
  username: string;
  email: string;
  role: string;
}

type Maybe<T> = T | null;

@Component
export default class UserForm extends Vue {
  public username: Maybe<string> = null;
  public userEmail: Maybe<string> = null;
  public errors: Maybe<string[]> = null;

  created() {
    if (this.isLoggedIn()) {
      this.getPassedUser().then(data => {
        this.username = data.username;
        this.userEmail = data.email;
      });
    }
  }

  public isLoggedIn(): boolean {
    return this.$store.state.currentUser.loggedIn;
  }

  private async getPassedUser(): Promise<User> {
    const post = await fetch(process.env.VUE_APP_API_URL + "/user", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + this.$store.state.currentUserToken
      }
    });
    const result = await post.json();
    return result.data;
  }

  public async registerUser(e: Event): Promise<void> {
    const payload = {
      username: (e.target as HTMLFormElement).username.value,
      email: (e.target as HTMLFormElement).email.value,
      password: (e.target as HTMLFormElement).password.value,
      confirmPassword: (e.target as HTMLFormElement).confirmPassword.value
    };
    const response = await fetch(process.env.VUE_APP_API_URL + "/user/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
    const result = await response.json();
    if (result.status !== 200) {
      this.errors = result.msg;
      this.$forceUpdate();
    } else {
      this.$router.push("/login");
    }
  }

  public async updateUser(e: Event): Promise<void> {
    this.$forceUpdate();
    const payload = this.getUpdatePayload(
      (e.target as HTMLFormElement).currentPassword.value,
      (e.target as HTMLFormElement).email.value,
      (e.target as HTMLFormElement).newPassword.value,
      (e.target as HTMLFormElement).confirmPassword.value
    );
    const response = await fetch(process.env.VUE_APP_API_URL + "/user/update", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + this.$store.state.currentUserToken
      },
      body: JSON.stringify(payload)
    });
    const result = await response.json();
    if (result.status !== 200) {
      this.errors = result.msg;
      this.$forceUpdate();
    } else {
      this.$router.push("/");
    }
  }

  private getUpdatePayload(password: string, newEmail: Maybe<string>, newPassword: Maybe<string>, confirmPassword: Maybe<string>): object {
    if (newEmail !== this.userEmail && !newPassword) {
      return { password, newEmail };
    } else if ((!newEmail || newEmail === this.userEmail) && newPassword) {
      return { password, newPassword, confirmPassword };
    } else {
      return { password, newEmail, newPassword, confirmPassword };
    }
  }
}
